import React, { useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Alert, Button, CircularProgress, Typography } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { useAuth } from '../contexts/AuthContext';
import { safeReturnTo } from '../api/client';
import AuthShell from './AuthShell';

export default function LoginPage() {
  const { user, ready, login } = useAuth();
  const [params] = useSearchParams();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const returnTo = safeReturnTo(params.get('return_to'));

  if (!ready) {
    return (
      <AuthShell>
        <CircularProgress size={28} />
      </AuthShell>
    );
  }
  if (user) {
    return <Navigate to={returnTo || '/'} replace />;
  }

  const handleLogin = async () => {
    setError('');
    setBusy(true);
    try {
      await login(returnTo);
    } catch (e) {
      setBusy(false);
      setError(e.response?.data?.detail || e.message || 'Could not start sign-in');
    }
  };

  return (
    <AuthShell>
      <Typography sx={{ mb: 2.5, color: 'text.secondary', fontSize: '0.9rem' }}>
        Use your Bernardo SSO account. You must already be registered in this app.
      </Typography>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <Button
        fullWidth
        size="large"
        variant="contained"
        startIcon={busy ? <CircularProgress size={16} color="inherit" /> : <LockOpenIcon />}
        onClick={handleLogin}
        disabled={busy}
      >
        {busy ? 'Redirecting…' : 'Sign in with Bernardo SSO'}
      </Button>
    </AuthShell>
  );
}